/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function() {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    if($(this).hasClass('js-noScroll')) return true;

    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;

    var gap = $('.l-header').innerHeight();

    position -= gap;
    
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

//スライダー
$(function(){
  $('.home-kv__slick').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false
    });
  });
});

//スライダー
$(function(){
  $('.results-slider__original').each(function(index, el) {
    const $slider = $(this);
    let $slides = $slider.find('.results-slider__originalSlides');
    let $slide = $slider.find('.results-slider__originalSlide');
    let $next = $slider.find('.results-slider__originalNext');
    let $prev = $slider.find('.results-slider__originalPrev');

    let now = 0;
    let len = $slide.length;

    init();

    function init() {
      $slides.append($slide.clone()).append($slide.clone());
      $slide = $slides.children();
      
      moveSlide();
      $slider.addClass('is-show');
    }

    $next.on('click', function () {
      nextSlide();
    });

    $prev.on('click', function () {
      prevSlide();
    });

    function nextSlide() {
      now ++;

      if(now >= len) {
        now = -1;
        $slider.addClass('is-stopAni');
        moveSlide();

        setTimeout(function(){
          $slider.removeClass('is-stopAni');
          now = 0;
          moveSlide();
        }, 10);
      } else {
        moveSlide();
      }
    }

    function prevSlide() {
      now --;

      if(now < 0) {
        now = len;
        $slider.addClass('is-stopAni');
        moveSlide();

        setTimeout(function(){
          $slider.removeClass('is-stopAni');
          now = len - 1;
          moveSlide();
        }, 10);
      } else {
        moveSlide();
      }
    }

    function moveSlide() {
      $slide.each(function (index, element) {
        const $t = $(this);
        let num = 0;
        
        num = index - (now + len);

        $t.attr('data-num', num);
      });
    }
  });
});

//スライダー
$(function(){
  $('.results-slider__slick').each(function(index, el) {
    const $slider = $(this);

    // 左右の透過の2周目ががたつく対応
    $slider.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
      $slider.find(".slick-slide").each((index, el) => {
        const $this = $(el),
        slickindex = $this.attr("data-slick-index");
        if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
          // 現在のスライドが最初のスライドでそこから最後のスライドに戻る場合
          if (slickindex == "-1") {
            // 最後のスライドに対してクラスを付与
            $this.addClass("is-active-next");
          } else {
            // それ以外は削除
            $this.removeClass("is-active-next");
          }
        } else if (nextSlide == 0) {
          // 次のスライドが最初のスライドの場合
          if (slickindex == slick.slideCount) {
            // 最初のスライドに対してクラスを付与
            $this.addClass("is-active-next");
          } else {
            // それ以外は削除
            $this.removeClass("is-active-next");
          }
        } else {
          // それ以外は削除
          $this.removeClass("is-active-next");
        }
      });
    });

    $slider.slick({
      autoplay: false,
      autoplaySpeed: 3000,
      fade: false,
      speed: 400,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: true,
      dots: false,
      centerMode: true,
      variableWidth: true
    });
  });
});

//スライダー
$(function(){
  $('.works-singleSlider__slick').each(function(index, el) {
    const $slider = $(this);
    const $thumb = $('.works-singleSlider__thumbs button');

    $slider.slick({
      autoplay: false,
      autoplaySpeed: 3000,
      fade: false,
      speed: 400,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: true,
      dots: false
    });

    $thumb.on('click', function () {
      const $t = $(this);
      let index = $thumb.index(this);

      $slider.slick('slickGoTo', index);
    });
  });
});

//スライダー
// $(function(){
//   $('.business-singleSlider__slick').each(function(index, el) {
//     const $slider = $(this);

//     $slider.slick({
//       autoplay: false,
//       autoplaySpeed: 3000,
//       fade: false,
//       speed: 400,
//       pauseOnFocus: false,
//       pauseOnHover: false,
//       pauseOnDotsHover: false,
//       arrows: true,
//       dots: true
//     });
//   });
// });

//フェード
$(function(){
  var fade = $('.u-fade, .js-fadeAni');

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function(){
  const $hd = $('.l-header');

  if($hd[0]) {
    const $mega = $('.p-mega');
    let nowSc = 0;
    let oldSc = 0;

    $(window).on('scroll', function () {
      run();
    });

    run();

    function run() {
      oldSc = nowSc;
      nowSc = $(window).scrollTop();

      if($(window).scrollTop() < 50) {
        if($hd.hasClass('is-sc')) {
          $hd.removeClass('is-sc');
          $mega.removeClass('is-sc');
        }
      } else if(oldSc < nowSc) {
        if(!$hd.hasClass('is-sc')) {
          $hd.addClass('is-sc');
          $mega.addClass('is-sc');
        }
      } else {
        $hd.removeClass('is-sc');
        $mega.removeClass('is-sc');
      }
    }
  }
});

$(function(){
  const $menu = $('.p-hd__menuSP button');

  if($menu[0]) {
    const $nav = $('.p-hnavSP');
    const $close = $('.p-hnavSP__closeB');

    $menu.on('click', function () {
      $menu.toggleClass('is-on');
      $nav.toggleClass('is-show');
    });

    $close.on('click', function () {
      $menu.removeClass('is-on');
      $nav.removeClass('is-show');
    });
  }
});

$(function(){
  const $parent = $('.p-ft__navParent');

  if($parent[0]) {

    $parent.children('a.-sp').on('click', function () {
      const $t = $(this);
      const $parent = $(this).parent();
      const $tar = $t.next('ul');

      if (window.matchMedia("(max-width: 991px)").matches) {
        $parent.toggleClass('is-on');
        $tar.stop().slideToggle(300);
      }
    });

    $(window).on('resize', function () {

      if (!window.matchMedia("(max-width: 991px)").matches) {
        $parent.removeClass('is-on');
        $parent.children('a.-sp').next('ul').removeAttr('style');
      }
    });
  }
});

$(function(){
  const $img = $('.js-scrollImg');

  if($img[0]) {
    $(window).on('resize scroll', function () {
      run();
    });

    run();

    function run() {
      $img.each(function (index, element) {
        const $t = $(this);
        const $imgImg = $t.find('img');

        let per = 0;

        let winT = $(window).scrollTop();
        let winH = $(window).innerHeight();
        let winB = winT + winH;

        let tT = $t.offset().top;
        let tH = $t.innerHeight();
        let tB = tT + tH;

        per = (winB - tT) / (winH + tH);

        if(per >= 0 && per <= 1) {
          $imgImg.each(function (index, element) {
            const $t2 = $(this);

            let t2T = $t2.offset().top;
            let t2H = $t2.innerHeight();
            let t2B = t2T + t2H;

            let y = 0;

            y = (t2H - tH) * per * -1;

            if(t2H - tH < 0) y = 0;

            $t2.css('transform', 'translateY(' + y + 'px)');
          });
        }
      });
    }
  }
});

$(function(){
  const $gotop = $('.p-ft__gotop');

  if($gotop[0]) {
    $(window).on('scroll', function () {
      run();
    });

    run();

    function run() {
      if($(window).scrollTop() > 600) {
        $gotop.addClass('is-show');
      } else {
        $gotop.removeClass('is-show');
      }
      if($(window).scrollTop() + $(window).innerHeight() > $(document).innerHeight() - 10) {
        $gotop.addClass('is-bottom');
      } else {
        $gotop.removeClass('is-bottom');
      }
    }
  }
});

$(function(){
  const $slider = $('.home-kvSlider');

  if($slider[0]) {
    const $slide = $('.home-kvSlider__slide');
    const $blur = $('.home-kvSlider__blur');
    const $navBtn = $('.home-kvSlider__navBtns button');
    const $names = $('.home-kvSlider__names p');

    let timer, timer2;
    let now = 0;
    let old = now;
    let slideLen = $slide.length;
    let navLock = false;
    let isPause = false;

    setTimeout(function(){
      $navBtn.eq(0).addClass('is-cr');
      $names.eq(0).addClass('is-cr');

      timer = setInterval(function(){
        runNext();
      }, 5000);

      $navBtn.on('click', function () {
        const index = $navBtn.index(this);

        if(index == now) {
          if(!isPause) {
            isPause = true;

            $navBtn.addClass('is-pause');

            clearInterval(timer);
          } else {
            isPause = false;

            $navBtn.removeClass('is-pause');

            timer = setInterval(function(){
              runNext();
            }, 5000);
          }
        } else {
          if(!isPause && !navLock) {
            navLock = true;

            setTimeout(function(){
              navLock = false;
            }, 1000);
            
            runNext(index);
          }
        }
      });
    }, 1000);

    function runNext(val = null) {
      old = now;

      if(val != null) {
        now = val;

        clearInterval(timer);

        timer = setInterval(function(){
          runNext();
        }, 5000);

        clearTimeout(timer2);
        $slide.removeClass('is-aniIn is-aniOut');
      } else {
        now ++;
      }

      if(now >= slideLen) now = 0;

      $slide.removeClass('is-cr');
      $slide.eq(now).addClass('is-cr is-aniIn');
      $slide.eq(old).addClass('is-aniOut');

      $navBtn.removeClass('is-cr');
      $navBtn.eq(now).addClass('is-cr');
      
      $names.removeClass('is-cr');
      $names.eq(now).addClass('is-cr');

      timer2 = setTimeout(function(){
        $slide.removeClass('is-aniIn is-aniOut');
      }, 3000);
    }
  }
});

$(function(){
  const $root = $('.p-tab');

  if($root[0]) {
    $root.each(function (index, element) {
      const $tab = $(this);
      const $btn = $tab.find('.p-tab__btn');
      const $panel = $tab.find('.p-tab__panel');

      const params = (new URL(document.location)).searchParams;
      const param = params.get('tab');

      $btn.on('click', function () {
        let index = $btn.index(this);

        changeTab(index);
      });

      init();

      function init(){
        changeTab(0);

        if(param) {
          $btn.each(function (index, element) {
            const $t = $(this);
            const dataName = $t.attr('data-name');
            if(param == dataName) {
              $t.trigger('click');
            }
          });
        }
      }

      function changeTab(index = 0) {
//        console.log(index);
        $btn.removeClass('is-cr').eq(index).addClass('is-cr');
        $panel.hide().eq(index).stop().fadeIn(300);
      }
    });
  }
});

$(function(){
  const $btn = $('.js-pConditionsClose');

  if($btn[0]) {
    const $inner = $('.p-conditions__inner2');
    const label1 = $btn.attr('aria-label');
    const label2 = $btn.attr('data-label2');

    $btn.on('click', function () {
      const $t = $(this);

      $btn.toggleClass('is-on');
      $inner.stop().slideToggle(300);

      if($btn.hasClass('is-on')) {
        $btn.attr('aria-expanded', 'false');
        $btn.attr('aria-label', label2);
        $inner.attr('aria-hidden', 'true');
      } else {
        $btn.attr('aria-expanded', 'true');
        $btn.attr('aria-label', label1);
        $inner.attr('aria-hidden', 'false');
      }
    });
  }
});

$(function(){
  const $btn = $('.js-megaBtn');

  if($btn[0]) {
    const $menu = $('.p-mega__block');
    const $close = $('.p-mega__close button');

    let now = 0;
    let old = now;

    $btn.on('click', function () {
      old = now;
      now = parseInt($(this).attr('data-mega-target'));
      runOpen();
    });

    $close.on('click', function () {
      runClose();
    });

    function runOpen() {
      const $t = $(this);
      const $tar = $('[data-mega-id=' + now + ']');

      if($tar[0]) {
        if(old > 0) {
          $menu.stop().slideUp(300);
          $tar.stop().delay(300).slideDown(300);
        } else {
          $tar.stop().slideDown(300);
        }
      }
    }

    function runClose() {
      if(now > 0) {
        old = now;
        now = 0;
        $menu.stop().slideUp(300);
      }
    }
  }
});

$('.js-openBtn').on('click', function() {
  let expanded = $(this).attr('aria-expanded') === 'true',
      controls = $(this).attr('aria-controls');
  $(this).attr('aria-expanded', !expanded);
  $('#' + controls).attr('aria-hidden', expanded);
});

$(function(){
  const $root = $('.news-catNav');

  $root.each(function (index, element) {
    const $nav = $(this);
    const $item = $nav.next('.news-list').find('.news-list__item');
    const $yLink = $nav.find('.news-catNav__y a');
    const $cat2Link = $nav.find('.news-catNav__cat2 a');

    refresh();

    $yLink.on('click', function () {
      const $t = $(this);

      $yLink.removeClass('is-cr');
      $t.addClass('is-cr');

      refresh();
    });

    $cat2Link.on('click', function () {
      const $t = $(this);

      $cat2Link.removeClass('is-cr');
      $t.addClass('is-cr');

      refresh();
    });

    function refresh() {
      const sel_y = $yLink.filter('.is-cr').text();
      const sel_cat2 = $cat2Link.filter('.is-cr').text();
      const isAllCat2 = $cat2Link.filter('.is-cr').attr('data-all');

      $item.hide();

      $item.each(function (index, element) {
        const $t = $(this);

        const data_y = $t.attr('data-y');
        const ys = data_y.split(',');

        const data_cat2 = $t.attr('data-cat2');
        const cat2s = data_cat2.split(',');

        let isShow = 0;

        for (let i = 0; i < ys.length; i++) {
          if(sel_y == ys[i]) isShow++;
        }

        console.log(isAllCat2);

        if(isAllCat2) {
          isShow ++;
        } else {
          for (let i = 0; i < cat2s.length; i++) {
            if(sel_cat2 == cat2s[i]) isShow++;
          }
        }

        if(isShow == 2) {
          $t.stop().fadeIn(300);
        }
      });
    }
  });
});

const $lang = $('html').attr('lang');
var $langHref = '';

if($lang == 'en-US') {
  $langHref = '/en';
} else if($lang == 'de-DE') {
  $langHref = '/de';
} else if($lang == 'zh-hans') {
  $langHref = '/zh-hans';
}
console.log($langHref);

$(function(){
  const $root = $('.p-conditions.-works');
  if($root[0]) {
    const $submit = $root.find('.js-conditionsSubmit');
    const $submitW = $root.find('.js-conditionsSubmitW');

    const $inputW = $root.find('input[name="w"]');
    const $selectU = $root.find('select[name="u"]');
    const $selectL = $root.find('select[name="l"]');
    const $selectI = $root.find('select[name="i"]');
    const $selectB = $root.find('select[name="b"]');

    const $selectLP = $root.find('select[name="lp"]');

    $selectLP.change(function (e) { 
      const $t = $(this);

      $selectL.find('option').each(function (index, element) {
        const $t2 = $(this);
        
        if($t2.parent().prop('tagName') == 'SPAN') {
          $t2.unwrap();
        }
      });

      $selectL.val('');

      if($t.val()) {
        $selectL.find('option').not('[data-parent="' + $t.val() + '"]').wrap('<span style="display:none"></span>');
      }
    });

    setInterval(function(){
      setLink();
    }, 100);

    function setLink() {
      let href = '/works/?list=1';

      if($inputW.val()) {
        href += '&w=' + encodeURI($inputW.val());
      }
      
      $submitW.attr('href', href);

      if($selectU.val()) {
        href += '&u=' + encodeURI($selectU.val());
      }

      if($selectL.val()) {
        href += '&l=' + encodeURI($selectL.val());
      }

      if($selectI.val()) {
        href += '&i=' + encodeURI($selectI.val());
      }

      if($selectB.val()) {
        href += '&b=' + encodeURI($selectB.val());
      }

      $submit.attr('href', $langHref + href);
    }
  }
});

$(function(){
  const $root = $('.results-search');

  if($root[0]) {
    const $submitW = $root.find('.js-conditionsSubmitW');
    const $submit = $root.find('.js-conditionsSubmit');

    const $inputW = $root.find('input[name="w"]');
    const $selectL = $root.find('select[name="l"]');

    const $selectLP = $root.find('select[name="lp"]');

    $selectLP.change(function (e) { 
      const $t = $(this);

      $selectL.find('option').each(function (index, element) {
        const $t2 = $(this);
        
        if($t2.parent().prop('tagName') == 'SPAN') {
          $t2.unwrap();
        }
      });

      $selectL.val('');

      if($t.val()) {
        $selectL.find('option').not('[data-parent="' + $t.val() + '"]').wrap('<span style="display:none"></span>');
      }
    });

    setInterval(function(){
      setLink();
    }, 100);

    function setLink() {
      let href = '/works/?list=1';

      if($inputW.val()) {
        href += '&w=' + encodeURI($inputW.val());
      }

      $submitW.attr('href', href);

      href = '/works/?list=1';

      if($selectL.val()) {
        href += '&l=' + encodeURI($selectL.val());
      }

      $submit.attr('href', $langHref + href);
    }
  }
});

$(function(){
  const $root = $('.p-conditions.-products');

  if($root[0]) {
    const $submit = $root.find('.js-conditionsSubmit');
    const $submitW = $root.find('.js-conditionsSubmitW');

    const $inputW = $root.find('input[name="w"]');
    const $selectU = $root.find('select[name="u"]');
    const $selectL = $root.find('select[name="l"]');
    const $selectI = $root.find('select[name="i"]');
    const $selectB = $root.find('select[name="b"]');

    const $selectLP = $root.find('select[name="lp"]');

    $selectLP.change(function (e) { 
      const $t = $(this);

      $selectL.find('option').each(function (index, element) {
        const $t2 = $(this);
        
        if($t2.parent().prop('tagName') == 'SPAN') {
          $t2.unwrap();
        }
      });

      $selectL.val('');

      if($t.val()) {
        $selectL.find('option').not('[data-parent="' + $t.val() + '"]').wrap('<span style="display:none"></span>');
      }
    });

    setInterval(function(){
      setLink();
    }, 100);

    function setLink() {
      let base = '/products/';
      let href = '';

      if($inputW.val()) {
        if(href) { href += '&'; } else { href += '?'}
        href += 'w=' + encodeURI($inputW.val());
      }
      
      $submitW.attr('href', href);

      if($selectU.val()) {
        if(href) { href += '&'; } else { href += '?'}
        href += 'u=' + encodeURI($selectU.val());
      }

      if($selectL.val()) {
        if(href) { href += '&'; } else { href += '?'}
        href += 'l=' + encodeURI($selectL.val());
      }

      if($selectI.val()) {
        if(href) { href += '&'; } else { href += '?'}
        href += 'i=' + encodeURI($selectI.val());
      }

      if($selectB.val()) {
        if(href) { href += '&'; } else { href += '?'}
        href += 'b=' + encodeURI($selectB.val());
      }

      $submit.attr('href', $langHref + base + href);
    }
  }
});

$(function(){
  const $root = $('.business-indexProducts');

  if($root[0]) {
    const $submitW = $root.find('.js-conditionsSubmitW');
    const $submit = $root.find('.js-conditionsSubmit');

    const $inputW = $root.find('input[name="w"]');
    const $selectL = $root.find('select[name="l"]');

    const $selectLP = $root.find('select[name="lp"]');

    $selectLP.change(function (e) { 
      const $t = $(this);

      $selectL.find('option').each(function (index, element) {
        const $t2 = $(this);
        
        if($t2.parent().prop('tagName') == 'SPAN') {
          $t2.unwrap();
        }
      });

      $selectL.val('');

      if($t.val()) {
        $selectL.find('option').not('[data-parent="' + $t.val() + '"]').wrap('<span style="display:none"></span>');
      }
    });

    setInterval(function(){
      setLink();
    }, 100);

    function setLink() {
      let href = '/products/';

      if($inputW.val()) {
        href += '?w=' + encodeURI($inputW.val());
      }

      $submitW.attr('href', href);

      href = '/products/';

      if($selectL.val()) {
        href += '?l=' + encodeURI($selectL.val());
      }

      $submit.attr('href', $langHref + href);
    }
  }
});

$(function(){
  const $root = $('.works-pSearch.-in');

  if($root[0]) {
    const $submitW = $root.find('.js-conditionsSubmitW');

    const $inputW = $root.find('input[name="w"]');

    setInterval(function(){
      setLink();
    }, 100);

    function setLink() {
      let href = '/products/?b=125';

      if($inputW.val()) {
        href += '&w=' + encodeURI($inputW.val());
      }

      $submitW.attr('href', $langHref + href);
    }
  }
});

$(function(){
  const $root = $('.works-pSearch.-gl');

  if($root[0]) {
    const $submitW = $root.find('.js-conditionsSubmitW');

    const $inputW = $root.find('input[name="w"]');

    setInterval(function(){
      setLink();
    }, 100);

    function setLink() {
      let href = '/works/?list=1&b=' + GLO;

      if($inputW.val()) {
        href += '&w=' + encodeURI($inputW.val());
      }

      $submitW.attr('href', $langHref + href);
    }
  }
});

//table　横スクロールアイコン（SP)
$(function(){
  const $tableWrap = $('.c-table');
  if($tableWrap[0]) {
    $tableWrap.on('touchend', function(){
      $tableWrap.addClass('is-arrow-hide');
    });
  }
});

//目次生成
$(function(){
  var con = $('.js-mokuji');
  var conTtl = $('.news-single-con h2');

  if(con.length) {
    // 目次の出力に使用する変数
    var toc = '<h2>' + myStringData.h3 + '</h2><ol>';
    // 目次の階層の判断に使用する変数
    var hierarchy;
    // h2の判断に使用する変数
    var element = 0;
    // 目次の項目数をカウントする変数
    var count = 0;

      conTtl.each(function(){
      // 目次の項目数のカウントを増加
      count ++;
      // h2タグにIDの属性値を指定
      this.id = 'chapter-' + count;

      toc += '<li><a href="#' + this.id + '">' + $(this).html() + '</a></li>';
    });

    toc += '</li></ol></div>';

    var tocObj = $(toc);

    tocObj.find('a[href^="#"]').click(function(){
      var speed = 500;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top - 90;

      if($('.header').css('position') == 'fixed') {
        position -= 60;
      }

      $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
    });

    if(count > 1) {
      con.prepend(tocObj);
    } else {
      con.hide();
    }
  }
});

//　問い合わせフォーム用
$(function(){
  $(".contact-con__input").each(function() {
    if ($(this).find("span.error").length == 1) {
      $(this).addClass("is-error");
      $(".contact-con__errorMsg").addClass("is-show");
    }
  });
});


// 膜構造建築物の防火規定チェッカー
$(() => {
  if (!document.querySelector('body.page-template-membrane_structures_fire_regulations')) return;

  const {createRouter, createWebHistory, useRoute} = VueRouter
  const {createApp, computed} = Vue;

  const articleComponents = {};
  document.querySelectorAll('#main .l-container template').forEach(template => {
    articleComponents[template.id] = { template: template.innerHTML };
  });

  const Home = {
    data() {
      return {
        article: null,
      };
    },
    components: articleComponents,
    template: `<component :is="currentArticle"></component>`,
    setup() {
      const route = useRoute();
      const currentArticle = computed(() => {
        return articleComponents[route.query.article || 'check-start'];
      });
      return {currentArticle};
    },
  }

  const routes = [
    { path: '/membrane_structures/fire_regulations/', component: Home },
  ];

  let initial = true;
  const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if ((!to.query.article || to.query.article === 'check-start') && !initial) {
        return {
          el: '.check-start-scroll-target',
          top: 100,
        };
      } else {
        initial = false;
        return { top: 0 }
      }
    },
  })

  const app = createApp({});
  app.use(router)
  app.mount('#app');
});

$(function(){
  const $fixBnrClose = $('.js-home-fixbnr__close');

  if($fixBnrClose[0]) {

    $fixBnrClose.on('click', function () {
      $('.home-fixbnr').hide();
    });

  }
});